export default __webpack_public_path__ + "static/media/katalog-2021.34f220d2.pdf";